import React, { useEffect } from 'react';
import ModalBasic from '../../components/Modal';
import { ListBulletIcon, SparklesIcon } from '@heroicons/react/24/outline';
import { isEmpty } from 'lodash';
import { getOrderSummary } from '../../redux/Reducers/CreateOrderReducer';
import toast from 'react-hot-toast';
import { amountCheckFn } from '../../utils/commonUtil';
import { useSelector } from 'react-redux';

export default function GroupFormSummary({ modalOpen, setModalOpen, isRush }) {
  const { selectedServices } = useSelector((state) => state.group);
  const { profileData } = useSelector((state) => state.profile);
  const { allServiceAddresses } = useSelector((state) => state.serviceAddresses);
  const [calculationLoading, setCalculationLoading] = React.useState(false);
  const [editOrderIsRush, setEditOrderIsRush] = React.useState(false);
  const [summary, setSummary] = React.useState({});
  const getOrderSummaryFn = () => {
    const items =
      selectedServices &&
      selectedServices?.map((service) => {
        if (service?.operation != 'DELETE') {
          return { service_id: service?.service_id, quantity: service?.quantity };
        }
      });
    const filtered = items?.filter((item) => item);
    const payload = {
      items: filtered || [],
      address_id: allServiceAddresses?.[0]?.id || null,
      is_rush: isRush,
    };
    if (!isEmpty(selectedServices)) {
      setCalculationLoading(true);
      const response = getOrderSummary(payload);
      response.then((res) => {
        if (res?.status === 200 || res?.status === 201) {
          setCalculationLoading(false);
          setSummary(res?.data || {});
        } else {
          setCalculationLoading(false);
          toast.error(res?.message || 'Something went wrong');
        }
      });
    } else {
      setCalculationLoading(false);
    }
  };

  useEffect(() => {
    getOrderSummaryFn();
  }, [selectedServices, isRush]);

  return (
    <ModalBasic id='group-form-summary-modal' modalOpen={modalOpen} setModalOpen={setModalOpen} title={''} width='md'>
      <div className='p-2'>
        {/* Services */}
        <div>
          <div className='mb-2 flex items-center gap-2'>
            <SparklesIcon className='text-client-800 h-6 w-6' />
            <span className='text-client-800 text-lg font-bold'>Services</span>
          </div>
          <hr className='border-client-800 mb-2 border-dashed' />
          {summary?.items?.map((service, idx) => (
            <div key={idx} className='mb-2 flex items-start justify-between'>
              <div>
                <div className='font-medium text-gray-600'>{service?.name}</div>
                <div className='text-sm text-gray-500'>Qty: {service?.quantity}</div>
              </div>
              <div className=''>{amountCheckFn(service?.client_fee)}</div>
            </div>
          ))}
        </div>

        {/* Order Summary */}
        <div className='mt-4'>
          <div className='mb-2 flex items-center gap-2'>
            <ListBulletIcon className='text-client-800 h-6 w-6' />
            <span className='text-client-800 text-lg font-bold'>Order Summary</span>
          </div>
          <hr className='border-client-800 mb-2 border-dashed' />
          <div className='mb-2 flex justify-between '>
            <span className='text-gray-500'>Subtotal:</span>
            <span>{amountCheckFn(summary?.subtotal)}</span>
          </div>
          {isRush && (
            <div className='mb-2 flex justify-between '>
              <span className='text-gray-500'>Priority Delivery:</span>
              <span>{amountCheckFn(summary?.priority_fee)}</span>
            </div>
          )}
          <div className='mb-2 flex justify-between '>
            <span className='text-gray-500'>Tip:</span>
            <span>{amountCheckFn(summary?.final_tip)}</span>
          </div>
          <div className='mb-3 flex justify-between '>
            <span className='text-gray-500'>Service Fee:</span>
            <span>{amountCheckFn(summary?.service_fee)}</span>
          </div>
          <div className='mt-2 flex items-center justify-between rounded-md bg-gray-100 px-2 py-2'>
            <span className='text-client-800 font-bold'>Estimated Total:</span>
            <span className='text-client-800 font-bold'>{amountCheckFn(summary?.estimated_total_cost)}</span>
          </div>
        </div>
      </div>
    </ModalBasic>
  );
}
